<ion-content [fullscreen]="true">
  <ion-row>
    <ion-col class="flex flex-col justify-center items-center">
      <ion-refresher slot="fixed" (ionRefresh)="doRefresh()">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-spinner class="mt-8" name="dots"></ion-spinner>
      @if (hasLoggedOut) {
      <ion-button class="mt-8" (click)="goToLogin()">
        Til innlogging
      </ion-button>
      }
    </ion-col>
  </ion-row>
</ion-content>
